 export enum FiltreContratSalarieEnum {
Tous = 0,
EnCours = 1,
ActifExercice = 2,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/FiltreContratSalarieEnum.ts